'use strict';

angular.module('theme').component('supplementsButton', {
	templateUrl: 'component/supplements-button.html',
	bindings: {
		productId: '<',
		maxAmount: '<',
		selected: '<',
		btnSmall: '<',
		onSelect: '&'
	},
	controller: function ($scope, $element, $attrs, ArticleService) {
		var self = this;

		this.isOpen = false;
		this.btnBlock = 'block' in $attrs;
		this.btnLarge = 'large' in $attrs;
		this.showLabel = 'showLabel' in $attrs;


		if (this.btnBlock) {
			$element.addClass('display-block');
		}

		this.amounts = _.range(0, this.maxAmount + 1);

		function getData() {
			self.price = undefined;

			if (!self.productId) {
				return;
			}

			ArticleService.getProduct(self.productId).then(function (product) {
				if (product.supplements.meat > 0) {
					self.price = product.supplements.meat;
				}
			});
		}

		$scope.$watch('$ctrl.productId', getData);
		$scope.$watch('$ctrl.selected', getData);

		this.select = function (amount) {
			self.selected = amount;
			self.onSelect({$amount: amount});
		};
	}
});
